// Saklanan duygu adını avatar rengine çevirir (D-666). Bilinmeyen bir değer
// (eski sürümden ya da bozulmuş kayıt) isim rengine düşer.
import { EMOTION_TINT, isEmotion } from './plutchik';

export function moodTint(value: string | null | undefined): readonly [string, string] | null {
  return isEmotion(value) ? EMOTION_TINT[value] : null;
}
